/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { TypeControleDto } from '../models/type-controle-dto';


/**
 * Fonctions de gestion des types de contrôles
 */
@Injectable({
  providedIn: 'root',
})
export class TypesControlesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation typeControleGetList
   */
  static readonly TypeControleGetListPath = '/api/types-controles/list';

  /**
   * Renvoie la liste des types de contrôles.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeControleGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeControleGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<TypeControleDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TypesControlesService.TypeControleGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TypeControleDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des types de contrôles.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeControleGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeControleGetList(params?: {
  }): Observable<Array<TypeControleDto>> {

    return this.typeControleGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TypeControleDto>>) => r.body as Array<TypeControleDto>)
    );
  }

  /**
   * Path part for operation typeControleLoadList
   */
  static readonly TypeControleLoadListPath = '/api/types-controles/load-list';

  /**
   * Renvoie la liste des types de contrôles (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeControleLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeControleLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, TypesControlesService.TypeControleLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des types de contrôles (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeControleLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeControleLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.typeControleLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation typeControleGet
   */
  static readonly TypeControleGetPath = '/api/types-controles/{id}';

  /**
   * Renvoie le type de contrôle spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeControleGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeControleGet$Response(params: {

    /**
     * Identifiant du type de contrôle
     */
    id: number;
  }): Observable<StrictHttpResponse<TypeControleDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesControlesService.TypeControleGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeControleDto>;
      })
    );
  }

  /**
   * Renvoie le type de contrôle spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeControleGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeControleGet(params: {

    /**
     * Identifiant du type de contrôle
     */
    id: number;
  }): Observable<TypeControleDto> {

    return this.typeControleGet$Response(params).pipe(
      map((r: StrictHttpResponse<TypeControleDto>) => r.body as TypeControleDto)
    );
  }

  /**
   * Path part for operation typeControlePut
   */
  static readonly TypeControlePutPath = '/api/types-controles/{id}';

  /**
   * Modifie le type de contrôle spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeControlePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeControlePut$Response(params: {

    /**
     * Identifiant du type de contrôle
     */
    id: number;

    /**
     * Les valeurs du type de contrôle
     */
    body: TypeControleDto
  }): Observable<StrictHttpResponse<TypeControleDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesControlesService.TypeControlePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeControleDto>;
      })
    );
  }

  /**
   * Modifie le type de contrôle spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeControlePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeControlePut(params: {

    /**
     * Identifiant du type de contrôle
     */
    id: number;

    /**
     * Les valeurs du type de contrôle
     */
    body: TypeControleDto
  }): Observable<TypeControleDto> {

    return this.typeControlePut$Response(params).pipe(
      map((r: StrictHttpResponse<TypeControleDto>) => r.body as TypeControleDto)
    );
  }

  /**
   * Path part for operation typeControleDelete
   */
  static readonly TypeControleDeletePath = '/api/types-controles/{id}';

  /**
   * Supprime le type de contrôle spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeControleDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeControleDelete$Response(params: {

    /**
     * Identifiant du type de contrôle à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TypesControlesService.TypeControleDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le type de contrôle spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeControleDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeControleDelete(params: {

    /**
     * Identifiant du type de contrôle à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.typeControleDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation typeControlePost
   */
  static readonly TypeControlePostPath = '/api/types-controles';

  /**
   * Crée le type de contrôle spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeControlePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeControlePost$Response(params: {
    body: TypeControleDto
  }): Observable<StrictHttpResponse<TypeControleDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesControlesService.TypeControlePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeControleDto>;
      })
    );
  }

  /**
   * Crée le type de contrôle spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeControlePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeControlePost(params: {
    body: TypeControleDto
  }): Observable<TypeControleDto> {

    return this.typeControlePost$Response(params).pipe(
      map((r: StrictHttpResponse<TypeControleDto>) => r.body as TypeControleDto)
    );
  }

}
